import { exists } from '@/api'
import { BibliographyClass, CollectionFlag, Prefix, SearchType } from '@/types'

export interface BibliographySearchResultItem {
  uid: string
  bibliographyClass: BibliographyClass
  prefix: Prefix
  bibliographyId: number
  searchType: SearchType
  marcType: string
  marcNo: string
  tooli: boolean
  displayMaterialFormat: string
  displayClass: string
  displayTitle: string
  displaySubtitle: string
  displayAuthor: string
  displayPublisher: string
  displayPublished: string
  displaySize: string
  shelfType: string
  callNo: string
  collectionFlag: CollectionFlag
  collectionNo: string
  handlingType: string
  canLendHandlingType: boolean
  collectionStatus: string
  shelfCount: string | null
  holdingCount: string | null
  orderCount: string | null
  reserveCount: string | null
  revision: string
  _fetched: boolean
}

export function BibliographySearchResultItemFromJSON(
  json: any
): BibliographySearchResultItem {
  return {
    uid: exists(json, 'bibliography_id')
      ? json.bibliography_id.toString()
      : json.marc ?? '',
    bibliographyClass: json.bibliographyClass,
    prefix: exists(json, 'prefix') ? json.prefix : Prefix.Real,
    bibliographyId: exists(json, 'bibliography_id') ? json.bibliography_id : 0,
    searchType: json.search_type,
    marcType: exists(json, 'marc_type') ? json.marc_type : '',
    marcNo: exists(json, 'marc') ? json.marc : '',
    tooli: exists(json, 'tooli') ? json.tooli : false,
    displayMaterialFormat: exists(json, 'display_material_format')
      ? json.display_material_format
      : '',
    displayClass: exists(json, 'display_class') ? json.display_class : '',
    displayTitle: exists(json, 'display_title') ? json.display_title : '',
    displaySubtitle: exists(json, 'display_subtitle')
      ? json.display_subtitle
      : '',
    displayAuthor: exists(json, 'display_author') ? json.display_author : '',
    displayPublisher: exists(json, 'display_publisher')
      ? json.display_publisher
      : '',
    displayPublished: exists(json, 'display_published')
      ? json.display_published
      : '',
    displaySize: exists(json, 'display_size') ? json.display_size : '',
    shelfType: exists(json, 'shelf_type') ? json.shelf_type : '',
    callNo: exists(json, 'call_no') ? json.call_no : '',
    collectionFlag: exists(json, 'collection_flag')
      ? json.collection_flag
      : null,
    collectionNo: exists(json, 'collection_no') ? json.collection_no : '',
    handlingType: exists(json, 'handling_type') ? json.handling_type : '',
    canLendHandlingType: exists(json, 'can_lend_handling_type')
      ? json.can_lend_handling_type
      : false,
    collectionStatus: exists(json, 'collection_status')
      ? json.collection_status
      : '',
    shelfCount: exists(json, 'shelf_count') ? json.shelf_count : '',
    holdingCount: exists(json, 'holding_count') ? json.holding_count : '',
    orderCount: exists(json, 'order_count') ? json.order_count : '',
    reserveCount: exists(json, 'reserve_count') ? json.reserve_count : '',
    revision: json.revision,
    _fetched: false
  }
}
